import React, { useState, useContext } from "react"
import { Navigate, Route, Routes as SwitchRoutes, useLocation, useNavigate } from "react-router-dom"
import { Box, Button, Grid, Snackbar, Alert, Backdrop, CircularProgress } from "@mui/material"
import { useTheme } from "@mui/material/styles"
import useMediaQuery from "@mui/material/useMediaQuery"
import HeaderRoot from "../../components/HeaderRoot"
import ActivePositions from "./MyBooks/ActivePositions"
import ChatRoot from "./Chat/ChatRoot"
import Search from "./Search/Search"
import History from "./History/History"
import {
  F_TRADING_ACTIVE,
  F_TRADING_ACTIVE_SHORT,
  F_TRADING_CHAT,
  F_TRADING_CHAT_SHORT,
  F_TRADING_HISTORY,
  F_TRADING_HISTORY_SHORT,
  F_TRADING_SEARCH,
  F_TRADING_SEARCH_SHORT,
} from "../../constants/routes"
import BackdropContext from "../../context/BackdropContext"
import StateProvider from "../../context/StateProvider"

const tabs = [
  {
    name: "Bücherlisten",
    route: F_TRADING_SEARCH,
  },
  {
    name: "Meine Bücher",
    route: F_TRADING_ACTIVE,
  },
  {
    name: "Chat",
    route: F_TRADING_CHAT,
  },
  {
    name: "Verlauf",
    route: F_TRADING_HISTORY,
  },
]

const Trading = () => {
  const location = useLocation()
  const navigate = useNavigate()
  const { backdropOpen } = useContext(BackdropContext)

  const [snackbarMsg, setSnackbarMsg] = useState(null)

  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"))

  const headerContent = (
    <Grid container spacing="4vh">
      {tabs.map((t) => (
        <Grid container item xs={12} columns={10} key={t.name} justifyContent="flex-end">
          <Grid item xs={8}>
            <Button
              variant="contained"
              onClick={() => navigate(t.route)}
              sx={{
                height: "8vh",
                width: "100%",
                // mx: "10%",
                textTransform: "none",
                boxShadow: "none",
                backgroundColor: location.pathname === t.route ? "white" : "secondary.main",
                color: location.pathname === t.route ? "secondary.main" : "white",
              }}>
              {t.name}
            </Button>
          </Grid>

          <Grid item xs={1}>
            <Box
              sx={{
                backgroundColor: "white",
                height: "8vh",
                width: "100%",
                visibility: location.pathname === t.route ? "visible" : "hidden",
              }}></Box>
          </Grid>
        </Grid>
      ))}
    </Grid>
  )

  const props = {
    isMobile: isMobile,
    setSnackbarMsg: setSnackbarMsg,
  }

  return (
    <StateProvider>
      <Box sx={{ height: "100vh", width: "100vw", backgroundColor: "primary.main", overflow: "hidden" }}>
        <HeaderRoot content={headerContent} showUserMenu isMobile={isMobile} />
        <Box
          id="pageScrollID"
          sx={{
            position: "fixed",
            top: isMobile ? 0 : "1vw",
            left: isMobile ? 0 : "12vw",
            borderRadius: isMobile ? 0 : "38px",
            backgroundColor: "white",
            height: isMobile ? "100vh" : "calc(100vh - 2vw)",
            width: isMobile ? "100vw" : "87vw",
            p: "1vw",
            // overflow: "hidden",
            overflow: "auto",
          }}>
          <SwitchRoutes location={location}>
            <Route path="/" element={<Navigate to={F_TRADING_SEARCH} replace />} />

            <Route path={F_TRADING_SEARCH_SHORT} element={<Search {...props} />} />
            <Route path={F_TRADING_ACTIVE_SHORT} element={<ActivePositions {...props} />} />
            <Route path={F_TRADING_CHAT_SHORT} element={<ChatRoot {...props} />} />
            <Route path={F_TRADING_HISTORY_SHORT} element={<History {...props} />} />

            <Route path="*" element={<Search {...props} />} />
          </SwitchRoutes>

          <Snackbar
            sx={{ color: "secondary.main" }}
            open={!!snackbarMsg}
            autoHideDuration={10000}
            onClose={(event, reason) => {
              if (reason === "clickaway") return
              setSnackbarMsg(null)
            }}>
            <Alert
              onClose={() => {
                setSnackbarMsg(null)
              }}
              severity="success"
              sx={{ width: "100%" }}>
              {snackbarMsg}
            </Alert>
          </Snackbar>

          <Backdrop sx={(theme) => ({ backgroundColor: "rgba(0,0,0,0.1)", zIndex: theme.zIndex.drawer + 1 })} open={backdropOpen}>
            <CircularProgress size={60} thickness={5} color="secondary" />
          </Backdrop>
        </Box>
      </Box>
    </StateProvider>
  )
}

export default Trading
